import React, { FC } from 'react';
import cls from 'classnames';

import { ButtonLinkProps } from './ButtonLink.types';

const ButtonLink: FC<ButtonLinkProps> = (props) => {
	const { variant = 'primary', hasUnderline = true, isEnabled = true, ...rest } = props;

	return (
		<button
			{...rest}
			className={cls('button-link', variant, { hasUnderline }, props.className)}
			disabled={!isEnabled}
			onClick={props.onClick}
		>
			{props.children}
		</button>
	);
};

ButtonLink.displayName = 'ButtonLink';

export default ButtonLink;
